const EXCLUDED_UPDATE_FIELDS = [
  '_login',
  '_password',
  'password_repeat',
  'isUser',
  'isAlarmParticipant',
]

export const isPasswordChangeRequested = (user) => (
  typeof user?.password === 'string' && user.password.length > 0
)

export const buildUserUpdatePayload = (user = {}) => Object.keys(user).reduce((payload, key) => {
  if (EXCLUDED_UPDATE_FIELDS.includes(key)) return payload
  if (key === 'password' && !isPasswordChangeRequested(user)) return payload

  payload[key] = user[key]
  return payload
}, {})
